
import { HiOutlineArrowSmallLeft } from 'react-icons/hi2';
export default function DoctorNotesFullMob({ closeFunction, data }) {
  return (
    <section className="fixed top-0 left-0 min-h-screen h-screen w-full bg-white z-30 xl:bg-black/25 xl:flex xl:justify-center xl:items-center ">
      <div className="bg-white relative p-4 pt-0 z-20 m-auto overflow-y-auto overscroll-contain scrollbar w-full h-full max-h-screen lg:max-w-4xl xl:max-w-5xl lg:py-4 lg:px-8 lg:max-h-[96vh]  lg:rounded-3xl xl:bg-bodybackground">
        <div className=" bg-white flex items-center sticky top-0 py-4 z-30 xl:bg-inherit">
          <div className="flex items-center gap-1">
          <HiOutlineArrowSmallLeft
              className="text-coalBlack text-2xl active:bg-sky-50"
              onClick={closeFunction}
            />
            <p className="text-lg font-medium text-coalBlack capitalize">
              Doctor Notes
            </p>
          </div>
          <p
            className="text-gray-500 text-sm font-medium min-w-10 p-2 cursor-pointer hidden xl:block ms-auto"
            onClick={closeFunction}
          >
            close
          </p>
        </div>
        <main
          className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 place-content-center"
          style={{ paddingBottom: '36%' }}
        >
         {data}
        </main>
      </div>
    </section>
  );
}